export const authorizationPrefix = 'Bearer ';
export const localStorageAuthToken = 'authToken';
export const localStorageAuthUser = 'authUser';
export const localStorageCartId = 'cartId';
export const localStorageToken = 'token';
export const webApiUrl = 'webApiUrl';



// WEBPACK FOOTER //
// ./src/app/_common/constants.ts